import { type Dispatch, type SetStateAction, useCallback, useState } from 'react'

import { useMounted } from '../useMounted'
/**
 * API equivalent to useState, but handles cases where asyncronizity may cause
 * setting after unmount.
 */
export const useStateSafe = <S>(initialState: S | (() => S)): [S, Dispatch<SetStateAction<S>>] => {
	const checkIfMounted = useMounted()

	const [state, setStateUnsafe] = useState(initialState)

	const setStateSafe = useCallback((value: SetStateAction<S>) => {
		if (checkIfMounted()) {
			setStateUnsafe(value)
		}
		// Depends on a ref, that is unchanging
	}, [])

	return [state, setStateSafe]
}
